module.exports = __webpack_public_path__ + "img/part4.1775439203884.png";